import { reactive } from "vue";
import { useI18n } from "vue-i18n";
import { HeaderDefinition } from "./types";

export const useHeaderDefinition = (defaultHeader: HeaderDefinition) => {

    const { t } = useI18n?.();
    const headerDefinition = reactive<HeaderDefinition>(defaultHeader);

    const setHeaderDefinition = (newInfo: HeaderDefinition) => {
        headerDefinition.title = newInfo.title;
        headerDefinition.showBackButton = newInfo.showBackButton ?? false;
        headerDefinition.goBackRoute = newInfo.goBackRoute ?? null;
        headerDefinition.showConfirmButton = newInfo.showConfirmButton ?? false;
        headerDefinition.confirmButtonText = newInfo.confirmButtonText ?? t?.("header.confirm") ?? "✔";
        headerDefinition.confirmCallback = newInfo.confirmCallback ?? null;
    };
    const setDefaultHeaderDefinition = () => setHeaderDefinition(defaultHeader);

    return {
        headerDefinition,
        setHeaderDefinition,
        setDefaultHeaderDefinition
    };
};
